import Axios from "axios";
import dotenv from "dotenv";

dotenv.config();

export const axios = () => {
  return Axios.create({
    baseURL: process.env.REACT_APP_REQUEST_ENDPOINT,
  });
};

export const authAxios = () => {
  const token = localStorage.getItem("token");
  
  let adminZone = localStorage.getItem("admin_zone");
  if (!adminZone && token) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const decoded = JSON.parse(atob(base64));
      adminZone = decoded.zone || (decoded.scope && decoded.scope.zones && decoded.scope.zones.length > 0 ? decoded.scope.zones.join(",") : null);
    } catch (e) {
      // ignore
    }
  }

  const instance = Axios.create({
    baseURL: process.env.REACT_APP_REQUEST_ENDPOINT,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  instance.interceptors.request.use((config) => {
    if (adminZone) {
      // 1. Remove existing zone from config.params if any
      if (config.params && config.params.zone !== undefined) {
        delete config.params.zone;
      }
      
      // 2. Remove existing zone= from config.url if any
      if (config.url && config.url.includes('zone=')) {
        const parts = config.url.split('?');
        if (parts.length > 1) {
          const path = parts[0];
          const query = parts[1];
          const newQuery = query.split('&').filter(p => !p.startsWith('zone=')).join('&');
          config.url = newQuery ? `${path}?${newQuery}` : path;
        }
      }

      // 3. Append the correct adminZone
      config.params = { ...config.params, zone: adminZone };
    }
    return config;
  }, (error) => Promise.reject(error));

  return instance;
};

export const basicAuth = () => {
  // const token = `${applore_con}:${"password"}`;
  // const encodedToken = Buffer.from(token).toString("base64");
  // console.log("ft", encodedToken);
  return Axios.create({
    baseURL: process.env.REACT_APP_REQUEST_ENDPOINT,
    headers: {
      Authorization:
        "Basic " +
        Buffer.from(
          process.env.REACT_APP_SAP_USERNAME +
            ":" +
            process.env.REACT_APP_SAP_PASSWORD
        ).toString("base64"),
    },
  });
};

export default authAxios;
